// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import InputIcon from "@mui/icons-material/Input";
import {changeExpense} from "../../WorkIssuanceExpense/expenseSlice";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function SetHistoryExpense({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const handleSetHistory = () => {
        // dispatchData(changeExpense({deferState: true, expenseNewStatus: '3242'}));
        // set the version to paid
        // dispatchData(changeExpense({deferState: false, expenseNewStatus: '3709'}));
        dispatchData(changeWorkIssuance({newStatus:  '3709', updateCdpStatus: true}));

        onMenuClose();
    };


    return (

        <Box>
            {(
                    // rowCdpStatus === "2351" ||  rowCdpStatus === "2359"
                    (rowCdpStatus !== "3709" && rowCdpStatus !== "2351" && rowCdpStatus !== "3242" && rowCdpStatus !== "4553" && rowCdpStatus !== "2359" && showExpense === true)
                ) &&
                <MenuItem onClick={handleSetHistory}>
                    <ListItemIcon>
                        <HistoryEduIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Set as History</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
